import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';
import InputLabel from '../common/InputLabel';
import { itemSelection } from '../../models/itemSelection.model';
import { AreaForm } from '../../models/area.model';


interface BasicDataProps {
  action: string;
  handleChange?: (e: any) => void;
  handleSelection?: (k: any, v: any) => void;
  areaForm: AreaForm;
  companiesList: itemSelection[];
}

const BasicData: React.FC<BasicDataProps> = ({
  action,
  handleChange,
  handleSelection,
  areaForm,
  companiesList
}) => {

  return (
    <React.Fragment>
      <div className='area-form-section'>
        <div className='area-form-section-title'>
          <p>Datos Básicos</p>
        </div>

        <div className='area-form-section-item'>
          <InputLabel
            label='Nombre'
            placeholder="Nombre"
            disabled={action === 'view'}
            name='name'
            value={areaForm.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className='area-form-section-item'>
          <InputLabel
            label='Teléfono'
            placeholder="Teléfono"
            disabled={action === 'view'}
            name='phone_number'
            value={areaForm.phone_number}
            onChange={handleChange}
          />
        </div>

        <div className='area-form-section-item'>
          <Autocomplete
            label='Compañía'
            placeholder='Compañía'
            disabled={action === 'view'}
            options={companiesList}
            value={areaForm.company}
            name='company'
            handleSelection={handleSelection}
            required
          />
        </div>

      </div>

    </React.Fragment>
  );
}

export default BasicData;